import { useNavigate } from "react-router-dom"
import error from "../Assets/error_Artboard 1.png"

export default function ErrorPage(){
    const navigate=useNavigate()
    return(
        <div className="flex w-screen px-24 py-12 gap-6 items-center">
            <img className="w-1/2" src={error} alt="error"/>
            <div className="flex flex-col gap-6">
                < h1 className="text-[4rem] antialiased font-bold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Trespasser!!! </h1>
                < h1 className="text-[3rem] leading-none pb-6 antialiased font-bold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Retreat now or face the consequences.</h1>
                <button className="shadow-sm rounded px-6 py-2.5 w-fit justify-center gap-3 flex items-center border hover:shadow-lg text-gray-600 text-xl font-medium transition-all duration-400 hover:bg-sky-500 hover:text-white" onClick={()=>{navigate(-1)}}>Go Back</button>
            </div>
        </div>
    )
}